import { gql } from '@common/hooks';

export const RelinkWorksListTemplateQuery = gql`
  mutation RelinkWorksListTemplate(
    $worksListTemplateId: ID!
    $staffingRequestAssignmentIds: [ID!]!
  ) {
    relinkWorksListTemplate(
      worksListTemplateId: $worksListTemplateId
      staffingRequestAssignmentIds: $staffingRequestAssignmentIds
    ) {
      worksListTemplate {
        id
      }
    }
  }
`;

export type RelinkWorksListTemplateResponse = {
  worksListTemplate: {
    id: string;
  };
};

export type RelinkWorksListTemplateArgs = {
  worksListTemplateId: string;
  staffingRequestAssignmentIds: string[];
};
